export default "__VITE_PUBLIC_ASSET__aa4e9f66__"